import React from "react";

const SignupHeadline = ({ signupType }) => {
    let content;

    switch (signupType) {
        case "team":
            content = <React.Fragment>Sign up the whole team</React.Fragment>;
            break;

        case "pro":
        case "color":
            content = "Download like a pro";
            break;

        case "for-mac":
            content = "Create an account";
            break;

        case "edu":
            content = "Sign up";
            break;

        default:
            content = "Join Noun Project for free";
    }

    return <h2 className="auth-headline">{content}</h2>;
};

export default SignupHeadline;
